export default __webpack_public_path__ + "static/media/errorImage.1dda2b5b.svg";